import * as React from "react";
import styled from "styled-components";

import { SaveNewDogTitleDto } from "../../../../../../api";
import { IDogTitlesSelectorProps, DogTitlesSelector } from "./DogTitlesSelector";
import { DogTitlesPanel } from "./DogTitlesPanel";
import { Classes, IPanel, PanelStack } from "@blueprintjs/core";
import { ETLCodes } from "../../../../../../locales";
import { useTl } from "../../../../../../hooks";

export interface IDogTitlesPanelStackProps extends Pick<IDogTitlesSelectorProps, "onSaved"> {
  dogId: number;
}

const Container = styled.div`
  flex: 1;
  height: 100%;
  & > .${Classes.PANEL_STACK} {
    height: 100%;
  }
`;

export const DogTitlesPanelStack: React.FunctionComponent<IDogTitlesPanelStackProps> = ({ dogId, onSaved }) => {
  const { t } = useTl();
  const onSectionSelected = React.useCallback(
    (data: SaveNewDogTitleDto) => {
      setPanelStack((currentStack) => [
        ...currentStack,
        {
          component: () => <DogTitlesSelector onSaved={onSaved} title={data} dogId={dogId}/>,
        },
      ]);
    },
    [dogId, onSaved]
  );

  const [panelStack, setPanelStack] = React.useState<IPanel[]>([
    {
      component: () => (
        <DogTitlesPanel onTitleSelected={onSectionSelected} dogId={dogId} onSaved={onSaved}/>
      ),
      title: t(ETLCodes.SelectSection),
    },
  ]);

  const removeFromPanelStack = React.useCallback(() => {
    setPanelStack((prev) => prev.slice(0, prev.length - 1));
  }, [setPanelStack]);

  return (
    <Container>
      <PanelStack stack={panelStack} showPanelHeader={true} onClose={removeFromPanelStack}/>
    </Container>
  );
};
